import React from 'react';
import { useEscapeToClose } from '../../../hooks/useEscapeToClose';
import { formatDate } from '../../../utils';
import { PAYMENT_SYSTEM_LABELS, type GatewayProvider } from '../../../types/payment';
import { RESUME_GATEWAY_DESCRIPTIONS } from './paymentDetails.constants';
import ModalSummary from './ModalSummary';
import styles from './CreateSubscriptionModal.module.css';

interface ResumeSubscriptionModalProps {
  open: boolean;
  loading: boolean;
  provider: GatewayProvider;
  pausedUntil: string;
  scheduledResumeDate: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

const ResumeSubscriptionModal: React.FC<ResumeSubscriptionModalProps> = ({
  open,
  loading,
  provider,
  pausedUntil,
  scheduledResumeDate,
  onConfirm,
  onCancel,
}) => {
  useEscapeToClose(onCancel, open);

  if (!open) return null;

  const gatewayLabel = PAYMENT_SYSTEM_LABELS[provider] ?? provider;
  const scheduledResumeLabel = scheduledResumeDate ? formatDate(scheduledResumeDate) : '—';

  return (
    <div className={styles.overlay}>
      <div
        className={styles.modal}
        onClick={(e) => e.stopPropagation()}
        style={{ width: 500, alignItems: 'stretch' }}
      >
        <div className={styles['icon-circle']} style={{ alignSelf: 'center' }}>
          <span className="material-symbols-outlined">play_circle</span>
        </div>

        <h3 className={styles.title}>Retomar assinatura</h3>
        <p className={styles.message}>
          A pausa será encerrada agora. A aluna volta imediatamente ao fluxo normal do portal e a
          próxima cobrança segue o ciclo natural da assinatura.
        </p>

        <ModalSummary
          items={[
            {
              label: 'Pausada até',
              value: pausedUntil ? formatDate(pausedUntil) : '—',
            },
            { label: 'Retorno original', value: scheduledResumeLabel },
            { label: 'Gateway', value: gatewayLabel },
          ]}
        />

        <p className={styles.validation} style={{ textAlign: 'left' }}>
          {RESUME_GATEWAY_DESCRIPTIONS[provider]}
        </p>

        <p className={styles.message} style={{ textAlign: 'left' }}>
          A data efetiva do retorno será registrada. Os dias já pausados continuam abatidos da linha
          do tempo, então a fidelidade e a próxima cobrança seguem corretos. Nenhuma assinatura,
          cobrança ou histórico é recriado.
        </p>

        <div className={styles.actions}>
          <button
            type="button"
            className={`${styles.btn} ${styles['btn-cancel']}`}
            onClick={onCancel}
            disabled={loading}
          >
            Voltar
          </button>
          <button
            type="button"
            className={`${styles.btn} ${styles['btn-confirm']}`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Retomando…' : 'Retomar assinatura'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResumeSubscriptionModal;
